import React from 'react'
import Input from '../../Components/Input/Input'
import { requiredValueValidator, minValueValidator, maxValueValidator } from '../../Validator/Rules'
import { useForm } from '../../Hooks/useForm'
import { Link } from 'react-router-dom'
import { GrHome } from 'react-icons/gr'

export default function ForgetPassword() {
    const [formState, onInputHandler] = useForm({
        mobile: {
            value: '',
            isValid: false
        },
    }, false)
    return (
        <>
            <div className='form-component'>
                <div className='form-wrapper'>
                    <h1 className='form-title'>فراموشی رمز عبور</h1>
                    <div className='form-inputs'>
                        <Input element='Input' id='mobile' placeholder='شماره موبایل' className='form-input' type='password' validitation=
                            {
                                [
                                    requiredValueValidator(),
                                    minValueValidator(4),
                                    maxValueValidator(10)
                                ]
                            }
                            onInputHandler={onInputHandler}
                        />
                    </div>

                    <button className={`form-btn ${formState.isFormValid ? 'succes' : 'error'}`} disabled={(!formState.isFormValid)}
                    >ارسال کد تایید</button>
                </div>
            </div>
        </>
    )
}
